module.exports = "/assets/data/f3237ba5b7357bca2ef0270c20ce7127-SG11.data.json";